import { render, staticRenderFns } from "./UpdateMultipleItems.vue?vue&type=template&id=25d1cddf&scoped=true"
import script from "./UpdateMultipleItems.vue?vue&type=script&lang=ts"
export * from "./UpdateMultipleItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d1cddf",
  null
  
)

export default component.exports